import { useEffect } from "react";
import { useLocation } from "react-router";
import { basePath } from "@/lib/session.js";

/**
 * Legacy /login route. Calendar Studio is now driven by the CRM-handoff SSO
 * flow: there is no manual login form. Hitting /login redirects to the SSO
 * start endpoint, which round-trips through TravelCRM and lands the user back
 * at the calendar with a cookie session set.
 */
export function LoginPage(): React.JSX.Element {
  const location = useLocation();

  useEffect(() => {
    const prefix = basePath();
    const params = new URLSearchParams(location.search);
    const next = params.get("next") || "/";
    window.location.replace(`${prefix}/api/v1/auth/sso/start?return=${encodeURIComponent(next)}`);
  }, [location.search]);

  return (
    <div className="flex h-dvh items-center justify-center text-sm text-muted-foreground">
      Redirecting to sign-in…
    </div>
  );
}
